<template>
	<section class="desc-warp">
		<div class="desc-box one-line">
			<span class="desc" v-for="(item, idx) in Contents" :key="idx">{{item.Content}}</span>
		</div>
	</section>
</template>

<script>
export default {
	name: 'SingleDesc',
	props: ['Contents'],
}
</script>

<style lang="scss" scoped>
.desc-warp {
	display: -webkit-box;
	-webkit-box-pack: justify;
}
.desc-box {
	-webkit-box-flex: 1;
	display: block;
	
}
.desc {
	margin-right: 10px;
	font-size: 13px;
	color: #666;
}
.desc:last-child {
	margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/template/desc/SingleDesc.vue